"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var utils_1 = require("../../utils");
exports.default = (0, utils_1.makeGenericNetworkReducer)(actions_1.FETCH_RELEASES, actions_1.ADD_RELEASE, undefined, undefined, "version");
